import { Box, Button, Stack, Text, TextLink, Heading, Dialog } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import { Trans } from 'react-i18next'
import CircleIcon from '@/components/icons/Group.svg'
import VerifiedBadge from '@/components/verified-badge'

const VerifyIdDialog = ({ open, onClose }) => {
  const { t } = useTranslation()
  return (
    <Dialog id="verify-id-dialog" width="xsmall" open={open} hideXButton={true}>
      <Box display="flex" justifyContent="center" alignItems="center" paddingBottom="gutter">
        <Box component="img" src={CircleIcon} />
        <Box position="absolute">
          <VerifiedBadge type="id" width={30} height={30} bottom={-4} verified={true} />
        </Box>
      </Box>

      <Stack space="small" align="center">
        <Heading level="6">
          {t(
            'l.listing.application.secure_docs.id_verification_required.heading',
            'ID Verification in Progress...'
          )}
        </Heading>
        <Trans
          t={t}
          i18nKey="l.listing.application.secure_docs.id_verification_required.description"
        >
          <Text size="standard" align="center">
            Once your identity is verified, you’ll receive access to view applications which
            includes the{' '}
            <TextLink href={`https://liv.rent/blog/livrent/trust-score-explained`} target="_blank">
              Trust Score
            </TextLink>{' '}
            - our comprehensive tenant screening tool.
          </Text>
        </Trans>
      </Stack>
      <Box paddingTop="large">
        <Button onClick={onClose}>
          {t('l.standalone_trustscore.form_verification_required_button_close1', 'Got it!')}
        </Button>
      </Box>
    </Dialog>
  )
}

export default VerifyIdDialog
